import React from 'react';
import { useParams } from 'react-router-dom';
import { GuestTestFlow } from '../components';

/**
 * Guest results page component that wraps GuestTestFlow
 * This provides a clean URL structure for guest test results
 */
const GuestResults: React.FC = () => {
  const { sessionId } = useParams();

  return (
    <GuestTestFlow 
      initialStep="results" 
      sessionId={sessionId}
    />
  );
};

export default GuestResults;